import Wrapper from "../../../layout/Wrapper";
import CustomerServiceComponent from "../../../screens/callcenters/customers";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Customers",
	description: "",
};

export default function CustomerService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CustomerServiceComponent />
		</Wrapper>
	);
}